import { Routes, Route } from "react-router-dom";

import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import Register from "./pages/register/Register";
import LoggedHome from "./pages/logged/loggedHome/LoggedHome";
import Profile from "./pages/logged/perfil/Profile";

import DefaultLayout from "./layout/DefaultLayout";
import LoggedLayout from "./layout/LoggedLayout";

// regras de acesso
import PrivateRoutes from "./routes/PrivateRoutes";
import PublicRoutes from "./routes/PublicRoutes";
import Biography from "./pages/logged/biography/Biography";
import MusicSets from "./pages/logged/musicSets/MusicSets";
import Events from "./pages/logged/events/Events";
import Video from "./pages/logged/video/Video";
import Photo from "./pages/logged/photo/Photo";
import Phrase from "./pages/logged/phrase/Phrase";
import SocialMedia from "./pages/logged/socialMedia/SocialMedia";
import Edit from "./pages/logged/edit/Edit";
import Url from "./pages/logged/url/Url";
import EditProfile from "./pages/logged/editProfile/EditProfile";
import Preview from "./pages/logged/preview/Preview";
import Share from "./pages/logged/share/Share";
import QrCode from "./pages/logged/qrcode/QrCode";

const AppRouter = () => {
  return (
    <Routes>
      {/* Rotas públicas (acessíveis somente se NÃO logado) */}
      <Route element={<PublicRoutes />}>
        <Route element={<DefaultLayout />}>
          <Route index element={<Home />} />
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
        </Route>
      </Route>

      {/* Rotas privadas (acessíveis somente se logado) */}
      <Route element={<PrivateRoutes />}>
        <Route element={<LoggedLayout />}>
          <Route path="logged-home" element={<LoggedHome />} />
          <Route path="perfil" element={<Profile />} />
          <Route path="biography" element={<Biography />} />
          <Route path="music-sets" element={<MusicSets />} />
          <Route path="events" element={<Events />} />
          <Route path="video" element={<Video />} />
          <Route path="photo" element={<Photo />} />
          <Route path="phrase" element={<Phrase />} />
          <Route path="social-media" element={<SocialMedia />} />
          <Route path="edit" element={<Edit />} />
          <Route path="url" element={<Url />} />
          <Route path="edit-profile" element={<EditProfile />} />
          <Route path="preview" element={<Preview />} />
          <Route path="share" element={<Share />} />
          <Route path="generate-qrcode" element={<QrCode />} />

          {/* outras rotas logadas futuras aqui */}
        </Route>
      </Route>
    </Routes>
  );
};

export default AppRouter;
